// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a4ca28a6","977":"a420be43"}[chunkId] + ".chunk.js";
};